module.exports = __webpack_public_path__ + "c59a64789f7074cc99508d56158042f3.svg";